import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { postWithAuth } from 'src/api';
import BomModal from 'src/components/BomModal';
import { useSelector } from 'react-redux';
import { RootStateOrAny } from 'src/store';
import { useQueryClient } from '@tanstack/react-query';
import { getSMCacheKeys } from 'src/pages/pmp/sm/utils';
import { useFormContext } from 'react-hook-form';

/**
 * LPWEB-1165 - SM BOM modal with a "Power from switch?" option, shown
 * when the SM is at a subscriber site with a tower switch (mirrors the
 * access point BOM modal).
 */
function SubscriberBomModal(props) {
  const { powerFromSwitch, ...restProps } = props;
  const { projectId } = useSelector((state: RootStateOrAny) => state.mainFrame);
  const [refreshHack, setRefreshHack] = useState(false);
  const { setValue } = useFormContext();
  const qc = useQueryClient();
  const { key } = getSMCacheKeys(projectId, props.objId);

  const tsActions = [];

  if (powerFromSwitch?.visible)
    tsActions.push({
      type: 'checkbox',
      label: 'Power from switch?',
      title: 'Configure switch equipment at subscriber site',
      onChange: (event, data) => {
        setValue('properties.power_from_switch.checked', data.checked);
        postWithAuth(
          `project/${projectId}/subscriber/${props.objId}/props`,
          { power_from_switch: { checked: data.checked } },
          'PATCH'
        )
          .then(() => {
            // Force the modal to request the updated BOM when the
            // checkbox changes state
            setRefreshHack((rh) => !rh);
          })
          .catch((err) => {});
      },
      defaultChecked: powerFromSwitch.checked,
      disabled: powerFromSwitch.enabled ? false : true,
    });

  return (
    <BomModal
      {...restProps}
      bomRefresh={{ status: refreshHack }}
      tsActions={tsActions}
      onCloseCallback={() => {
        // Reload the SM so it contains the updated
        // "power_from_switch" settings
        qc.invalidateQueries({ queryKey: key });
      }}
    />
  );
}

export default injectIntl(SubscriberBomModal);
